import React from 'react';
import AppConfirmDialog from '../../../AppConfirmDialog';
import ProvisionService from '../../../../services/ProvisionService';
import Service from '../../../../types/Service';
import { CrownOutlined } from '@ant-design/icons';

export default PromoteReplicaButton;

export type PromoteReplicaButtonProps = {
    service: Service;
};

function PromoteReplicaButton({ service }: PromoteReplicaButtonProps) {
    const handleOk = async () => {
        try {
            await ProvisionService.promoteReplica(
                service.getClusterUuid(),
                service.getServiceUuid()
            );
        } catch (e: any) {}
    };
    return (
        <AppConfirmDialog
            label="Promote Replica"
            onOk={handleOk}
            title="WARNING!"
            content="During this operation, the current primary is drained, which means new writes are blocked and outstanding writes are completed before the replica is promoted to the new primary. The current primary becomes a replica of the new primary."
            actionIcon={<CrownOutlined />}
        />
    );
}
